import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faUserPlus, faEdit, faBan, faEnvelope, faUserCheck, faKey } from '@fortawesome/free-solid-svg-icons';
import { showToast } from '../Modais/Toast';
import { AdicionarUsuarioModal } from '../Modais/Modal';
import Swal from 'sweetalert2';

function getCookie(nome) {
    var nomeEQ = nome + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1,c.length);
      if (c.indexOf(nomeEQ) === 0) return c.substring(nomeEQ.length,c.length);
    }
    return null;
}

const Usuarios = ({ handleBackToCards, showToast }) => {
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddUserModal, setShowAddUserModal] = useState(false); // Estado para controlar o modal
    const [editingUser, setEditingUser] = useState(null);

    // Busca os usuários da API
    const fetchUsuarios = async () => {
        setLoading(true);
        try {
            const token = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/buscar`, {
                method: 'POST',
                headers: {
                    'Authority': token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({})
            });

            const result = await response.json();
            
            if (result.status === "ok") {
                setUsuarios(result.lista);
            } else {
                showToast(result.mensagem || 'Erro ao carregar usuários', 'error');
            }
        } catch (error) {
            console.error('Erro ao buscar usuários:', error);
            showToast('Erro ao carregar usuários', 'error');
        } finally {
            setLoading(false);
        }
    };
  
    const handleAddUser = async (usuarioData) => {
        try {
            if (!usuarioData.nome || !usuarioData.email) {
                showToast('Preencha todos os campos obrigatórios', 'error');
                return;
            }

            const token = getCookie("info");
            const senhaTemporaria = "TempPass@" + Math.random().toString(36).slice(-8);
            
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/cadastrar`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authority': token || '',
                },
                body: JSON.stringify({
                    nome: usuarioData.nome,
                    email: usuarioData.email,
                    cargo: usuarioData.cargo || 'user',
                    senha: senhaTemporaria,
                    confirmar_Senha: senhaTemporaria
                })
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.mensagem || 'Erro ao cadastrar usuário');
            }

            const result = await response.json();
            
            if (result.status === "ok") {
                showToast('Usuário cadastrado com sucesso! Um e-mail foi enviado para que ele defina sua senha.', 'success');
                fetchUsuarios();
                setShowAddUserModal(false);
            } else {
                throw new Error(result.mensagem || 'Erro ao cadastrar usuário');
            }
        } catch (error) {
            console.error('Erro detalhado:', error);
            showToast(error.message || 'Erro ao cadastrar usuário', 'error');
        }
    };

    const handleUpdateUser = async (usuarioData) => {
        try {
            if (!usuarioData.nome || !usuarioData.email) {
                showToast('Preencha todos os campos obrigatórios', 'error');
                return;
            }

            const token = getCookie("info");
            
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/atualizar`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authority': token || '',
                },
                body: JSON.stringify({
                    id: usuarioData.id,
                    nome: usuarioData.nome,
                    email: usuarioData.email,
                    cargo: usuarioData.cargo,
                    status: usuarioData.status
                })
            });

            const result = await response.json();
            
            if (result.status === "ok") {
                showToast('Usuário atualizado com sucesso!', 'success');
                fetchUsuarios();
                setEditingUser(null);
            } else {
                throw new Error(result.mensagem || 'Erro ao atualizar usuário');
            }
        } catch (error) {
            console.error('Erro ao atualizar usuário:', error);
            showToast(error.message || 'Erro ao atualizar usuário', 'error');
        }
    };

    // Desativar usuário
    const handleDesativarUsuario = async (usuarioId, usuarioNome) => {
        const { isConfirmed } = await Swal.fire({
            title: 'Desativar usuário?',
            text: `"${usuarioNome}" perderá acesso ao sistema.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Desativar',
            cancelButtonText: 'Cancelar'
        });
        if (!isConfirmed) return;

        try {
            const token = getCookie("info");
            
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/desativar`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authority': token || '',
                },
                body: JSON.stringify({ id: usuarioId })
            });

            const result = await response.json();
            
            if (result.status === "ok") {
                showToast('Usuário desativado com sucesso!', 'success');
                fetchUsuarios();
            } else {
                throw new Error(result.mensagem || 'Erro ao desativar usuário');
            }
        } catch (error) {
            console.error('Erro ao desativar usuário:', error);
            showToast(error.message || 'Erro ao desativar usuário', 'error');
        }
    };

    // Reenviar link de ativação
    const handleReenviarLink = async (usuarioId, usuarioEmail) => {
        const { isConfirmed } = await Swal.fire({
            title: 'Reenviar link?',
            text: `Será enviado um e-mail de ativação para "${usuarioEmail}".`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Enviar',
            cancelButtonText: 'Cancelar'
        });
        if (!isConfirmed) return;

        try {
            const token = getCookie("info");
            
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/reenviarLinkAtivacao`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authority': token || '',
                },
                body: JSON.stringify({ id: usuarioId })
            });

            const result = await response.json();
            
            if (result.status === "ok") {
                showToast('Link de ativação reenviado com sucesso!', 'success');
            } else {
                throw new Error(result.mensagem || 'Erro ao reenviar link');
            }
        } catch (error) {
            console.error('Erro ao reenviar link:', error);
            showToast(error.message || 'Erro ao reenviar link', 'error');
        }
    };

    // Ativar usuário (para usuários inativos)
    const handleAtivarUsuario = async (usuarioId, usuarioEmail) => {
        const { isConfirmed } = await Swal.fire({
            title: 'Ativar usuário?',
            text: `Um link de acesso será enviado para "${usuarioEmail}".`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Ativar',
            cancelButtonText: 'Cancelar'
        });
        if (!isConfirmed) return;

        try {
            const token = getCookie("info");
            
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/ativar`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authority': token || '',
                },
                body: JSON.stringify({ id: usuarioId })
            });

            const result = await response.json();
            
            if (result.status === "ok") {
                showToast('Link de ativação enviado com sucesso!', 'success');
                fetchUsuarios();
            } else {
                throw new Error(result.mensagem || 'Erro ao ativar usuário');
            }
        } catch (error) {
            console.error('Erro ao ativar usuário:', error);
            showToast(error.message || 'Erro ao ativar usuário', 'error');
        }
    };

    // Resetar 2FA do usuário
    const handleToggleModo2FA = async (usuario) => {
        const novoModo = usuario.modo_2fa === 'dispositivo' ? 'sempre' : 'dispositivo';
        const label = novoModo === 'dispositivo' ? 'Confiar dispositivo — não pedir 2FA toda vez' : '2FA obrigatório em cada login';
        const { isConfirmed } = await Swal.fire({
            title: 'Alterar modo 2FA?',
            text: `${usuario.nome}: ${label}`,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
        });
        if (!isConfirmed) return;
        try {
            const token = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/modo_2fa`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authority': token || '' },
                body: JSON.stringify({ id_usuario: usuario.id, modo: novoModo })
            });
            const result = await response.json();
            if (result.status === 'ok') {
                showToast(`2FA atualizado para: ${label}`, 'success');
                fetchUsuarios();
            } else {
                showToast(result.mensagem || 'Erro ao atualizar 2FA', 'error');
            }
        } catch {
            showToast('Erro ao atualizar modo 2FA', 'error');
        }
    };

    const handleResetar2FA = async (usuarioId, usuarioNome) => {
        const { isConfirmed } = await Swal.fire({
            title: 'Resetar 2FA?',
            text: `"${usuarioNome}" precisará cadastrar o autenticador novamente no próximo login.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Resetar',
            cancelButtonText: 'Cancelar'
        });
        if (!isConfirmed) return;

        try {
            const token = getCookie("info");
            
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/resetar2fa`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authority': token || '',
                },
                body: JSON.stringify({ id_usuario: usuarioId })
            });

            const result = await response.json();
            
            if (result.status === "ok") {
                showToast('2FA resetado com sucesso!', 'success');
            } else {
                throw new Error(result.mensagem || 'Erro ao resetar 2FA');
            }
        } catch (error) {
            console.error('Erro ao resetar 2FA:', error);
            showToast(error.message || 'Erro ao resetar 2FA', 'error');
        }
    };

    useEffect(() => {
        fetchUsuarios();
    }, []);

    const getStatusClass = (status) => {
        switch(status) {
            case 'ativo': return 'status-ativo';
            case 'bloqueado': return 'status-bloqueado';
            case 'pendente': return 'status-pendente';
            case 'inativo': return 'status-inativo';
            default: return 'status-padrao';
        }
    };

    const getInitials = (name) => {
        if (!name) return '';
        const parts = name.split(' ').filter(Boolean);
        if (parts.length === 0) return '';
        if (parts.length === 1) return parts[0][0].toUpperCase();
        return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    };

    return (
        <section className="usuarios-container">
                <AdicionarUsuarioModal
                    show={showAddUserModal || editingUser !== null }
                    fecharModal={() => {setShowAddUserModal(false);
                                        setEditingUser(null);
                    }}
                    salvarUsuario={editingUser ? handleUpdateUser : handleAddUser}
                    usuario={editingUser}
                    isEditing={editingUser !== null}
                />
                <div className="header-right">
                    <h2>Gerenciar  Usuários</h2>
                    <button className="btn-add-user" onClick={() => setShowAddUserModal(true)}>
                        <FontAwesomeIcon icon={faUserPlus} /> Adicionar Usuário
                    </button>
                </div>

                {loading ? (
                    <div className="loading">Carregando usuários...</div>
                ) : (
                    <div className="usuarios-table">
                        <div className="usuario-table-header">
                            <div className="header-cell">Usuário</div>
                            <div className="header-cell">Último Acesso</div>
                            <div className="header-cell">Cargo</div>
                            <div className="header-cell">Status</div>
                            <div className="header-cell">Ações</div>
                        </div>

                        <div className="table-body">
                            {usuarios.map(usuario => (
                                <div key={usuario.id} className="user-card">
                                    <div className="user-cell">
                                        <div className="user-info">
                                            <div className="user-avatar" >
                                                {getInitials(usuario.nome)}
                                            </div>
                                            <div>
                                                <div className="user-name">{usuario.nome}</div>
                                                <div className="user-email">{usuario.email}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="user-cell">
                                        <div className="access-date">{usuario.ultimo_acesso_data}</div>
                                        <div className="access-time">{usuario.ultimo_acesso_hora}</div>
                                    </div>
                                    
                                    <div className="user-cell">
                                        <div className="user-role">{usuario.cargo === 'root' ? 'Admin' : usuario.cargo}</div>
                                    </div>
                                    
                                    <div className="user-cell">
                                        <div className={`user-status ${getStatusClass(usuario.status)}`}>
                                            {usuario.status}
                                        </div>
                                    </div>
                                    
                                    <div className="user-cell user-actions">
                                        {/* Botão Editar */}
                                        <button 
                                            className="btn-edit"
                                            onClick={() => setEditingUser({
                                                id: usuario.id,
                                                nome: usuario.nome,
                                                email: usuario.email,
                                                cargo: usuario.cargo,
                                                status: usuario.status
                                            })}
                                            title="Editar usuário"
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>

                                        {/* Botão Reenviar Link - apenas para pendentes */}
                                        {usuario.status === 'pendente' && (
                                            <button 
                                                className="btn-resend"
                                                onClick={() => handleReenviarLink(usuario.id, usuario.email)}
                                                title="Reenviar link de ativação"
                                            >
                                                <FontAwesomeIcon icon={faEnvelope} />
                                            </button>
                                        )}

                                        {/* Botão Desativar - apenas para ativos e pendentes */}
                                        {(usuario.status === 'ativo' || usuario.status === 'pendente') && (
                                            <button 
                                                className="btn-deactivate"
                                                onClick={() => handleDesativarUsuario(usuario.id, usuario.nome)}
                                                title="Desativar usuário"
                                            >
                                                <FontAwesomeIcon icon={faBan} />
                                            </button>
                                        )}

                                        {/* Botão Ativar - apenas para inativos e bloqueados */}
                                        {(usuario.status === 'inativo' || usuario.status === 'bloqueado') && (
                                            <button 
                                                className="btn-activate"
                                                onClick={() => handleAtivarUsuario(usuario.id, usuario.email)}
                                                title="Reativar usuário"
                                            >
                                                <FontAwesomeIcon icon={faUserCheck} />
                                            </button>
                                        )}

                                        {/* Botão Resetar 2FA - apenas para usuários ativos */}
                                        {usuario.status === 'ativo' && (
                                            <button
                                                className="btn-reset-2fa"
                                                onClick={() => handleResetar2FA(usuario.id, usuario.nome)}
                                                title="Resetar 2FA"
                                            >
                                                <FontAwesomeIcon icon={faKey} />
                                            </button>
                                        )}

                                        {/* Toggle modo 2FA */}
                                        {usuario.status === 'ativo' && (
                                            <button
                                                onClick={() => handleToggleModo2FA(usuario)}
                                                title={usuario.modo_2fa === 'dispositivo' ? '2FA: confiar dispositivo (clique para exigir sempre)' : '2FA: exigido sempre (clique para confiar dispositivo)'}
                                                style={{
                                                    background: 'transparent',
                                                    border: '1px solid',
                                                    borderColor: usuario.modo_2fa === 'dispositivo' ? '#4caf50' : '#888',
                                                    color: usuario.modo_2fa === 'dispositivo' ? '#4caf50' : '#888',
                                                    borderRadius: '6px',
                                                    padding: '6px 10px',
                                                    cursor: 'pointer',
                                                    fontSize: '13px'
                                                }}
                                            >
                                                {usuario.modo_2fa === 'dispositivo' ? '🔓' : '🔒'}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            
        </section>
    );
};

export default Usuarios;